// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetSkeleton-modulecontainer__MYKga";
var _2 = "ProfileContactsWidgetSkeleton-moduledivider__qGnhz Divider-moduleDivider__dL3Vg";
var _3 = "ProfileContactsWidgetSkeleton-modulefooter__yPb_w Skeleton-moduleSkeleton__Mlrfv";
var _4 = "ProfileContactsWidgetSkeleton-moduleheader__e_FNd Skeleton-moduleSkeleton__Mlrfv";
var _5 = "ProfileContactsWidgetSkeleton-moduleitem__dH5Cl";
var _6 = "ProfileContactsWidgetSkeleton-modulerowBottom__bFEbs Skeleton-moduleSkeleton__Mlrfv";
var _7 = "ProfileContactsWidgetSkeleton-modulerowTop__rcSeo Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "container", _2 as "divider", _3 as "footer", _4 as "header", _5 as "item", _6 as "rowBottom", _7 as "rowTop" }
